if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('change', this.onTierChange.bind(this));
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton =
          this.querySelector('[type="submit"]') ||
          document.querySelector(`[type="submit"][form="${this.form.getAttribute('id')}"]`);
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initializeBoxSizeFromUrl();
      }

      onTierChange(event) {
        const boxSizeInput = event.target.closest('[data-wntn-box-size]');
        if (boxSizeInput?.checked) {
          this.applyBoxSizeSelection(boxSizeInput);
          return;
        }

        const tierInput = event.target.closest('[data-wntn-card-tier]');
        if (!tierInput || !tierInput.checked) return;

        this.dataset.wntnSelectedTierQuantity = tierInput.value;
        const quantityInput = this.form.querySelector('[name="quantity"]');
        if (quantityInput) quantityInput.value = tierInput.value;

        const priceContainer = this.querySelector('[data-wntn-card-tier-price]');
        const currentPrice = priceContainer?.querySelector('[data-wntn-card-tier-current]');
        const comparePrice = priceContainer?.querySelector('[data-wntn-card-tier-compare]');
        const unitPrice = this.querySelector('[data-wntn-card-tier-unit-price]');
        if (currentPrice) currentPrice.textContent = tierInput.dataset.wntnTierPrice;
        if (comparePrice) {
          comparePrice.textContent = tierInput.dataset.wntnTierComparePrice;
          comparePrice.hidden = !tierInput.dataset.wntnTierComparePrice;
        }
        if (unitPrice) unitPrice.textContent = tierInput.dataset.wntnTierUnitPrice;
      }

      initializeBoxSizeFromUrl() {
        const requestedSize = new URLSearchParams(window.location.search).get('box_size');
        if (requestedSize !== '5') return;

        const fiveBoxInput = this.form.querySelector('[data-wntn-box-size][value="5"]');
        if (!fiveBoxInput) return;

        fiveBoxInput.checked = true;
        this.applyBoxSizeSelection(fiveBoxInput);
        window.setTimeout(() => this.applyBoxSizeSelection(fiveBoxInput), 500);
        window.setTimeout(() => this.applyBoxSizeSelection(fiveBoxInput), 1500);
      }

      applyBoxSizeSelection(boxSizeInput) {
        const variantIdInput = this.variantIdInput;
        const currentPrice = this.querySelector('[data-wntn-box-price-current]');
        const comparePrice = this.querySelector('[data-wntn-box-price-compare]');
        const unitPrice = this.querySelector('span[data-wntn-box-unit-price]');
        const selectedSize = boxSizeInput.value;

        if (variantIdInput) variantIdInput.value = boxSizeInput.dataset.wntnBoxVariantId;
        if (currentPrice) currentPrice.textContent = boxSizeInput.dataset.wntnBoxPrice;
        if (comparePrice) {
          comparePrice.textContent = boxSizeInput.dataset.wntnBoxComparePrice;
          comparePrice.hidden = !boxSizeInput.dataset.wntnBoxComparePrice;
        }
        if (unitPrice) unitPrice.textContent = boxSizeInput.dataset.wntnBoxUnitPrice;

        const depositInput = this.form.querySelector('[name="properties[_deposit_units]"]');
        if (depositInput && boxSizeInput.dataset.wntnBoxDepositUnits) {
          depositInput.value = boxSizeInput.dataset.wntnBoxDepositUnits;
        }

        const productIdInput = this.form.querySelector('[name="product-id"]');
        if (productIdInput && boxSizeInput.dataset.wntnBoxProductId) {
          productIdInput.value = boxSizeInput.dataset.wntnBoxProductId;
        }

        this.form
          .querySelectorAll('.bs-bundle-id-input, .bs-parent-variant-input, .bs-included-products-input')
          .forEach((input) => {
          if (!Object.hasOwn(input.dataset, 'wntnInitialValue')) {
            input.dataset.wntnInitialValue = input.value;
          }
          if (selectedSize === '3') {
            input.disabled = false;
            if (input.dataset.wntnInitialValue) input.value = input.dataset.wntnInitialValue;
          } else {
            input.disabled = true;
          }
          });

        const card = this.closest('.card');
        card?.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          link.href = boxSizeInput.dataset.wntnBoxUrl;
        });
        card?.querySelectorAll('.card__heading a').forEach((link) => {
          link.textContent = boxSizeInput.dataset.wntnBoxTitle;
        });
        const cardImage = card?.querySelector('.card__media img');
        if (cardImage && boxSizeInput.dataset.wntnBoxImage) {
          cardImage.src = boxSizeInput.dataset.wntnBoxImage;
          cardImage.srcset = boxSizeInput.dataset.wntnBoxImage;
          cardImage.alt = boxSizeInput.dataset.wntnBoxTitle;
        }

        const productRoot = this.closest('product-info');
        if (productRoot) {
          productRoot.querySelectorAll('.product__title h1, .product__title h2').forEach((title) => {
            title.textContent = boxSizeInput.dataset.wntnBoxTitle;
          });

          const productPrice = productRoot.querySelector(`[id="price-${this.dataset.sectionId}"]`);
          const salePrice = productPrice?.querySelector('.price__sale .price-item--sale.price-item--last');
          const compareAtPrice = productPrice?.querySelector('.price__sale s.price-item--regular');
          const regularPrice = productPrice?.querySelector('.price__regular .price-item--regular');
          const productUnitPrice = productPrice?.querySelector('.unit-price .price-item--last');
          if (salePrice) salePrice.textContent = boxSizeInput.dataset.wntnBoxPrice;
          if (regularPrice) regularPrice.textContent = boxSizeInput.dataset.wntnBoxPrice;
          if (compareAtPrice) compareAtPrice.textContent = boxSizeInput.dataset.wntnBoxComparePrice;
          if (productUnitPrice) productUnitPrice.textContent = boxSizeInput.dataset.wntnBoxUnitPrice;

          const descriptionTemplate = this.form.querySelector(
            `template[data-wntn-box-description="${selectedSize}"]`
          );
          if (descriptionTemplate) {
            productRoot.querySelectorAll('.product__description').forEach((description) => {
              description.innerHTML = descriptionTemplate.innerHTML;
            });
          }
          this.updateBoxWineDescriptions(selectedSize);
          this.updateBoxAccordionDetails(selectedSize, productRoot);

          const mainImage = productRoot.querySelector('[id^="GalleryViewer-"] img');
          const thumbnailImage = productRoot.querySelector('[id^="Thumbnail-"]');
          [mainImage, thumbnailImage].forEach((image) => {
            if (!image || !boxSizeInput.dataset.wntnBoxImage) return;
            image.src = boxSizeInput.dataset.wntnBoxImage;
            image.srcset = boxSizeInput.dataset.wntnBoxImage;
            image.alt = boxSizeInput.dataset.wntnBoxTitle;
          });

          const nextUrl = boxSizeInput.dataset.wntnBoxUrl;
          if (nextUrl) window.history.replaceState({}, '', nextUrl);
        }

        if (this.submitButton) {
          this.submitButton.setAttribute(
            'aria-label',
            `${boxSizeInput.dataset.wntnBoxTitle} in den Warenkorb legen`
          );
        }
      }

      updateBoxAccordionDetails(selectedSize, productRoot) {
        const detailTemplate = this.form.querySelector('template[data-wntn-box-accordion-details="5"]');
        const accordionKeys = {
          geschmack: 'taste',
          'food pairing': 'pairing',
          analytisch: 'analytics',
        };
        const wineDetails = [...(detailTemplate?.content.querySelectorAll('[data-wntn-box-wine-detail]') || [])].map(
          (wine) => ({
            title: wine.querySelector('[data-wntn-wine-title]')?.textContent.trim() || '',
            quantity: Number.parseInt(wine.dataset.wntnWineQuantity, 10) || 1,
            taste: wine.querySelector('[data-wntn-wine-taste]')?.textContent.trim() || '',
            pairing: wine.querySelector('[data-wntn-wine-pairing]')?.textContent.trim() || '',
            energy: wine.querySelector('[data-wntn-wine-energy]')?.textContent.trim() || '',
            carbohydrates: wine.querySelector('[data-wntn-wine-carbohydrates]')?.textContent.trim() || '',
            sugar: wine.querySelector('[data-wntn-wine-sugar]')?.textContent.trim() || '',
            alcohol: wine.querySelector('[data-wntn-wine-alcohol]')?.textContent.trim() || '',
            type: wine.querySelector('[data-wntn-wine-type]')?.textContent.trim() || '',
            sweetness: wine.querySelector('[data-wntn-wine-sweetness]')?.textContent.trim() || '',
            origin: wine.querySelector('[data-wntn-wine-origin]')?.textContent.trim() || '',
            grape: wine.querySelector('[data-wntn-wine-grape]')?.textContent.trim() || '',
          })
        );
        const displayTitle = (wine) => `${wine.title}${wine.quantity > 1 ? ` (${wine.quantity}×)` : ''}`;
        const appendLabeledLine = (container, label, value) => {
          if (!value) return;
          container.append(document.createTextNode(`${label}: ${value}`), document.createElement('br'));
        };

        productRoot.querySelectorAll('.product__accordion').forEach((accordion) => {
          const heading = accordion.querySelector('.accordion__title')?.textContent.trim().toLowerCase();
          const accordionKey = accordionKeys[heading];
          const content = accordion.querySelector('.accordion__content');
          if (!accordionKey || !content) return;

          if (!Object.hasOwn(content, 'wntnBoxOriginalHtml')) {
            content.wntnBoxOriginalHtml = content.innerHTML;
          }
          content.innerHTML = content.wntnBoxOriginalHtml;

          if (selectedSize !== '5' || wineDetails.length === 0) return;

          content.replaceChildren();

          if (accordionKey === 'taste' || accordionKey === 'pairing') {
            wineDetails.forEach((wine) => {
              const paragraph = document.createElement('p');
              const title = document.createElement('strong');
              title.textContent = `${displayTitle(wine)}: `;
              paragraph.append(title, document.createTextNode(wine[accordionKey]));
              content.append(paragraph);
            });
            return;
          }

          const sulfiteNotice = document.createElement('p');
          sulfiteNotice.append('Hinweis:', document.createElement('br'), 'enthält Sulfite');
          content.append(sulfiteNotice);

          wineDetails.forEach((wine) => {
            const paragraph = document.createElement('p');
            const title = document.createElement('strong');
            title.textContent = displayTitle(wine);
            paragraph.append(title, document.createElement('br'));
            paragraph.append('Nährwerte (pro 100 ml):', document.createElement('br'));
            appendLabeledLine(paragraph, 'Energie', wine.energy);
            appendLabeledLine(paragraph, 'Kohlenhydrate', wine.carbohydrates);
            appendLabeledLine(paragraph, 'davon Zucker', wine.sugar);
            paragraph.append('Angaben zum alkoholischen Getränk:', document.createElement('br'));
            appendLabeledLine(paragraph, 'Alkoholgehalt', wine.alcohol);
            appendLabeledLine(paragraph, 'Getränketyp', wine.type);
            appendLabeledLine(paragraph, 'Süßegrad', wine.sweetness);
            appendLabeledLine(paragraph, 'Herkunft', wine.origin);
            appendLabeledLine(paragraph, 'Rebsorte', wine.grape);
            paragraph.lastElementChild?.remove();
            content.append(paragraph);
          });

          const bottleNotice = document.createElement('p');
          bottleNotice.append('Flasche:', document.createElement('br'), 'Recycling-Code 1', document.createElement('br'));
          bottleNotice.append('Polyethylenterephthalat (PET)');
          content.append(bottleNotice);
        });
      }

      updateBoxWineDescriptions(selectedSize) {
        const wineList = document.querySelector('[data-wntn-box-wine-list]');
        if (!wineList || wineList.dataset.wntnBoxSize === selectedSize) return;

        wineList.querySelectorAll('[data-wntn-box-extra-wine]').forEach((item) => item.remove());

        if (selectedSize === '5') {
          const template = this.form.querySelector('template[data-wntn-box-extra-wines="5"]');
          const sourceCard = wineList.querySelector('.multicolumn-list__item');
          const extraWines = template?.content.querySelectorAll('[data-wntn-box-extra-wine-data]') || [];

          extraWines.forEach((extraWine, index) => {
            if (!sourceCard) return;

            const card = sourceCard.cloneNode(true);
            const baseId = wineList.id.replace('Slider-', 'Slide-');
            const image = card.querySelector('.multicolumn-card__image');
            const title = card.querySelector('.multicolumn-card__info h3');
            const description = card.querySelector('.multicolumn-card__info .rte');
            const imageUrl = extraWine.dataset.wntnBoxExtraWineImage;

            card.id = `${baseId}-extra-${index + 1}`;
            card.dataset.wntnBoxExtraWine = '';
            card.removeAttribute('data-shopify-editor-block');
            card.querySelector('.multicolumn-card__info .link')?.remove();

            if (image && imageUrl) {
              image.src = `${imageUrl}&width=1000`;
              image.srcset = `${imageUrl}&width=500 500w, ${imageUrl}&width=1000 1000w`;
              image.alt = extraWine.dataset.wntnBoxExtraWineTitle;
            }
            if (title) title.textContent = extraWine.dataset.wntnBoxExtraWineTitle;
            if (description) {
              description.innerHTML = extraWine.querySelector('[data-wntn-box-extra-wine-description]').innerHTML;
            }

            wineList.appendChild(card);
          });
        }

        wineList.dataset.wntnBoxSize = selectedSize;
        wineList.scrollLeft = 0;
        wineList.closest('slider-component')?.resetPages?.();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.upsellCheckInProgress) return;

        this.handleErrorMessage();

        if (this.isWntnUpsellProduct()) {
          this.upsellCheckInProgress = true;
          this.submitButton.setAttribute('aria-disabled', true);

          try {
            if (!(await this.hasWntnRegularCartProduct())) {
              this.handleErrorMessage(
                this.dataset.wntnUpsellMessage ||
                  'Upselling-Produkte können nur in Verbindung mit anderen Produkten gekauft werden.'
              );
              return;
            }
          } catch (error) {
            console.error('Upsell cart validation failed', error);
            this.handleErrorMessage(window.cartStrings?.error || 'Der Warenkorb konnte nicht geprüft werden.');
            return;
          } finally {
            this.upsellCheckInProgress = false;
            this.submitButton.removeAttribute('aria-disabled');
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const productInfo = document.getElementById(`ProductInfo-${this.dataset.sectionId}`) || this.closest('product-info');
        const selectedVolumeTier = productInfo?.querySelector(
          `input[name="wntn-volume-tier-${this.dataset.sectionId}"][data-tier-quantity]:checked`
        );
        const selectedFormTierQuantity = parseInt(this.dataset.wntnSelectedTierQuantity || '', 10);
        const selectedTierQuantity = selectedVolumeTier
          ? parseInt(selectedVolumeTier.dataset.tierQuantity || selectedVolumeTier.value, 10)
          : NaN;
        const formQuantityInput = this.form.querySelector('[name="quantity"]');
        const quantityInput = formQuantityInput || productInfo?.querySelector('[name="quantity"]');
        const formQuantity = parseInt(quantityInput?.value || '1', 10);
        let quantity = formQuantity;
        if (Number.isFinite(selectedFormTierQuantity)) {
          quantity = selectedFormTierQuantity;
        } else if (Number.isFinite(selectedTierQuantity)) {
          quantity = selectedTierQuantity;
        }
        if (quantityInput) {
          quantityInput.value = quantity;
        }
        if (!formQuantityInput) {
          const hiddenQuantityInput =
            this.form.querySelector('input[data-wntn-submit-quantity]') || document.createElement('input');
          hiddenQuantityInput.type = 'hidden';
          hiddenQuantityInput.name = 'quantity';
          hiddenQuantityInput.dataset.wntnSubmitQuantity = 'true';
          hiddenQuantityInput.value = quantity;
          if (!hiddenQuantityInput.parentNode) this.form.appendChild(hiddenQuantityInput);
        }

        const selectedBoxSize = this.form.querySelector('[data-wntn-box-size]:checked');
        if (selectedBoxSize) this.applyBoxSizeSelection(selectedBoxSize);

        const formData = new FormData(this.form);
        if (selectedBoxSize) {
          formData.set('id', selectedBoxSize.dataset.wntnBoxVariantId);
          formData.set('properties[_deposit_units]', selectedBoxSize.dataset.wntnBoxDepositUnits);
          if (selectedBoxSize.value === '5') {
            formData.delete('properties[_BS_bundleId]');
            formData.delete('properties[_BS_parentVariant]');
            formData.delete('properties[Included Products]');
          }
        }
        formData.set('quantity', quantity);
        const threeBoxVariantId = this.dataset.wntnThreeBoxVariantId;
        const hasSelectedVolumeTier = Number.isFinite(selectedFormTierQuantity) || selectedVolumeTier;
        const addThreeBox = threeBoxVariantId && hasSelectedVolumeTier && quantity === 3;
        const addCrateProperties = hasSelectedVolumeTier && quantity >= 6;
        if (addCrateProperties) {
          formData.set('properties[_wntn_pack_type]', 'kiste');
          formData.set('properties[_wntn_quantity_min]', '6');
          formData.set('properties[_wntn_quantity_step]', '6');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (addThreeBox) {
          config.headers['Content-Type'] = 'application/json';
          const properties = {};
          formData.forEach((value, key) => {
            if (key.startsWith('properties[') && key.endsWith(']')) {
              properties[key.slice(11, -1)] = value;
            }
          });
          const boxGroupId = `wntn-box-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const boxedProperties = {
            ...properties,
            _wntn_box_group: boxGroupId,
            _wntn_box_role: 'wine',
            _wntn_box_size: '3',
          };
          config.body = JSON.stringify({
            items: [
              {
                id: Number(formData.get('id')),
                quantity,
                properties: boxedProperties,
              },
              {
                id: Number(threeBoxVariantId),
                quantity: 1,
                properties: {
                  _wntn_box_group: boxGroupId,
                  _wntn_box_role: 'box',
                  _wntn_box_size: '3',
                },
              },
            ],
            sections: formData.get('sections'),
            sections_url: formData.get('sections_url'),
          });
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      isWntnUpsellProduct() {
        const marker = this.form.querySelector('[name="properties[_cart_upsell]"]')?.value;
        const productLink = this.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
        const productPath = productLink?.getAttribute('href') || window.location.pathname;
        return `${marker || ''}`.toLowerCase() === 'true' || `${productPath || ''}`.toLowerCase().includes('upsell');
      }

      isWntnUpsellCartLine(item) {
        const marker = `${item?.properties?._cart_upsell || ''}`.toLowerCase();
        const title = `${item?.product_title || item?.title || ''}`.toLowerCase();
        const handle = `${item?.handle || ''}`.toLowerCase();
        return marker === 'true' || title.includes('upsell') || handle.includes('upsell');
      }

      isWntnSupportCartLine(item) {
        const role = `${item?.properties?._wntn_box_role || ''}`.toLowerCase();
        return (
          item?.variant_id === 55334564692302 ||
          item?.variant_id === 55150991409486 ||
          item?.variant_id === 60685224673614 ||
          role === 'box' ||
          role === 'byob_box'
        );
      }

      async hasWntnRegularCartProduct() {
        const response = await fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);

        const cart = await response.json();
        return (cart.items || []).some(
          (item) => !this.isWntnSupportCartLine(item) && !this.isWntnUpsellCartLine(item)
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper && errorMessage) {
          this.errorMessageWrapper = document.createElement('div');
          this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
          this.errorMessageWrapper.setAttribute('role', 'alert');
          this.errorMessageWrapper.innerHTML = '<span class="product-form__error-message"></span>';
          this.form.before(this.errorMessageWrapper);
        }
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
